export function checkIfUrlHasExternalLink(url) {
  if (url) {
    return url?.includes('.') || url?.includes('https://') || url?.includes('www.');
  }
  return false;
}
